import React, { useEffect, useState, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// import FlightLoader from "../AirSearch/Flightloader";
import AirplaneLoader from "./AirplaneLoader";
const formatTime = (iso) => { if (!iso) return "N/A"; return iso.split("T")[1]?.substring(0, 5) || iso; };
const formatDur = (val) => { if (!val) return "N/A"; if (typeof val === "string") return val; return `${Math.floor(val / 60)}h ${val % 60}m`; };
const depHour = (dep) => parseInt((dep || "00").split(":")[0]);
const timeSlot = (dep) => { const h = depHour(dep); if (h < 6) return 1; if (h < 12) return 2; if (h < 18) return 3; return 4; };

const AIRLINE_LOGO_MAP = {
  // "6E": "indigo",
  // "AI": "airindia",
};
const CLASS_NAMES = {
  0: "Economy",
  1: "Premium Economy",
  2: "Business",
  3: "First Class",
};
const getLogoFileName = (code) => AIRLINE_LOGO_MAP[code] || code || "default";

const getDisplayData = (flight) => {
  const onwardSegs = flight?.AirSegments?.filter(s => s.SegmentType === "Onword") || [];
  const returnSegs = flight?.AirSegments?.filter(s => s.SegmentType === "Return") || [];

  const seg     = onwardSegs[0] || flight?.AirSegments?.[0];
  const lastSeg = onwardSegs[onwardSegs.length - 1] || seg;
  const onwardFare = flight?.AirlineFares?.find(f => f.ContractType === "Onword") || flight?.AirlineFares?.[0];
  const fare = flight?.AirlineFare || onwardFare || {};

  const returnSeg     = returnSegs[0];
  const lastReturnSeg = returnSegs[returnSegs.length - 1];
  const onwardStops = onwardSegs.length > 1 ? onwardSegs.length - 1 : 0;
  const returnStops = returnSegs.length > 1 ? returnSegs.length - 1 : 0;

  const onwardDur = flight?.ContractDuration?.find(d => d.ContractType === "Onword")?.TripDuration || seg?.Duration || "";
  const returnDur = flight?.ContractDuration?.find(d => d.ContractType === "Return")?.TripDuration || returnSeg?.Duration || "";

  return {
    airline:      seg?.AirlineName    || "Airline",
    airlineCode:  seg?.AirlineCode    || "",
    code:         `${seg?.AirlineCode || ""}-${seg?.FlightNumber || ""}`,
    logo:         (seg?.AirlineCode   || "?").substring(0, 2),
    dep:        formatTime(seg?.DepartureDateTime),
    arr:        formatTime(lastSeg?.ArrivalDateTime),
    durMin:     onwardDur,
    stops:      onwardStops,
    price:      fare?.GrossFare || fare?.BaseFare || flight?.GrossFare || 0,
    baseFare:   fare?.BaseFare  || 0,
    tax:        fare?.TaxFare   || fare?.Tax || 0,
    baggage:    seg?.BaggageAllowed?.CheckInBaggage || "N/A",
    handBag:    seg?.BaggageAllowed?.HandBaggage    || "N/A",
    origin:     seg?.Origen         || "DEL",
    originCity: seg?.SourceCity     || "",
    dest:       lastSeg?.Destination     || "BOM",
    destCity:   lastSeg?.DestinationCity || "",
    segType:    seg?.SegmentType    || "",
    isRoundTrip:      returnSegs.length > 0,
    retDep:           formatTime(returnSeg?.DepartureDateTime),
    retArr:           formatTime(lastReturnSeg?.ArrivalDateTime),
    retAirlineCode:   returnSeg?.AirlineCode || seg?.AirlineCode || "",
    retOrigin:        returnSeg?.Origen       || "",
    retOriginCity:    returnSeg?.SourceCity   || "",
    retDest:          lastReturnSeg?.Destination     || "",
    retDestCity:      lastReturnSeg?.DestinationCity || "",
    retDurMin:        returnDur,
    retStops:         returnStops,
    retBaggage:       returnSeg?.BaggageAllowed?.CheckInBaggage || "N/A",
    fareGroups:       flight?.FareGroups?.FareGroup || [],
    refundable: flight?.Refundable === true,
  };
};

const S = {
  page: { fontFamily: "'Segoe UI', system-ui, sans-serif", background: "#F5F6FA", minHeight: "100vh", color: "#1a1a2e" },
  topBar: { background: "#034494", padding: "10px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" ,   maxWidth: 1147,margin: "0 auto",  width: "100%",  boxSizing: "border-box",  },
  metaRow: { display: "flex", flex: 1, alignItems: "center" ,gap: 24 },
  metaItem: { display: "flex", flexDirection: "column", gap: 2 },
  metaLabel: { fontSize: 12.5, color: "#fff", fontWeight: 700, letterSpacing: ".3px" },
  metaVal: { fontSize: 12.5, color: "#ffffffcc" },
  modifyBtn: { background: "#e91e63", color: "#fff", border: "none", borderRadius: 4, padding: "8px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
  modPanel: { background: "#fff", borderBottom: "1px solid #E8EAF0", padding: "16px 20px" },
  tripRadios: { display: "flex", gap: 6, marginBottom: 14 },
  searchRow: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr auto", gap: 8, alignItems: "end" },
  fieldBox: { background: "#F5F6FA", border: "1px solid #E8EAF0", borderRadius: 8, padding: "8px 12px", cursor: "pointer" },
  fieldLbl: { fontSize: 10, color: "#9295A4", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 3, fontWeight: 500 },
  fieldCity: { fontSize: 20, fontWeight: 700, lineHeight: 1.1, color: "#1a1a2e" },
  fieldSub: { fontSize: 11, color: "#9295A4" },
  swapBtn: { background: "#fff", border: "1px solid #E8EAF0", width: 30, display: "flex", alignItems: "center", justifyContent: "center", color: "#6B6F80", fontSize: 12 },
  btnSearch: { background: "#1a73e8", color: "#fff", border: "none", borderRadius: 8, padding: "12px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer", height: 44 },
  mainArea: { display: "flex", gap: 14, padding: "14px 20px" , maxWidth: 1180, margin: "0 auto",  width: "100%", boxSizing: "border-box"},
  filterCard: { width: 230, flexShrink: 0, background: "#fff", border: "1px solid #E8EAF0", borderRadius: 16, overflow: "hidden", alignSelf: "start", boxShadow: "0 2px 12px rgba(16,40,92,.06)" },
filterHead: { padding: "16px 18px", background: "linear-gradient(135deg, #10285C 0%, #1a3a7a 100%)", display: "flex", justifyContent: "space-between", alignItems: "center" },
filterHeadTitle: { fontSize: 14, fontWeight: 700, color: "#fff", display: "flex", alignItems: "center", gap: 8 },
resetLink: { fontSize: 11.5, color: "#fff", cursor: "pointer", background: "rgba(255,255,255,.15)", border: "none", fontWeight: 600, padding: "5px 10px", borderRadius: 20, transition: "background .15s ease" },
filterSec: { padding: "16px 18px", borderBottom: "1px solid #F0F1F5" },
filterSecHead: { display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer", marginBottom: 12 },
filterTitle: { fontSize: 12, fontWeight: 700, color: "#14213D", textTransform: "uppercase", letterSpacing: ".5px", display: "flex", alignItems: "center", gap: 6 },
chevron: { fontSize: 10, color: "#9295A4", transition: "transform .2s ease" },
stopBtns: { display: "flex", gap: 8 },
  resultsArea: { flex: 1, minWidth: 0 , maxWidth: 940  },
  sortTabs: { display: "flex", background: "#fff", border: "1px solid #E8EAF0", borderRadius: 10, overflow: "hidden", marginBottom: 10 },
  sortTab: { flex: 1, padding: "10px 8px", textAlign: "center", cursor: "pointer", fontSize: 12 },
  navBtns: { display: "flex", gap: 8, marginBottom: 10, alignItems: "center" },
  navBtn: { padding: "6px 14px", border: "1px solid #E8EAF0", borderRadius: 8, fontSize: 12, cursor: "pointer", background: "#fff", color: "#6B6F80" },
  colHead: { display: "grid", gridTemplateColumns: "2fr 1.1fr 1.2fr 1.1fr 1.2fr", gap: 8, padding: "4px 14px", fontSize: 10, color: "#9295A4", fontWeight: 600, textTransform: "uppercase", letterSpacing: ".4px", marginBottom: 4 },
  flightCard: { background: "#fff", border: "1px solid #E8EAF0", borderRadius: 10, marginBottom: 8, overflow: "hidden" },
  flightRow: { display: "grid", gridTemplateColumns: "2fr 1.1fr 1.2fr 1.1fr 1.2fr", gap: 6, padding: "12px 14px", alignItems: "center" },
  returnRow: { display: "grid", gridTemplateColumns: "2fr 1.1fr 1.2fr 1.1fr 1.2fr", gap: 6, padding: "10px 14px", alignItems: "center", background: "#f8f9ff", borderTop: "1px dashed #c7d7f5" },
  detailBar: { borderTop: "1px solid #F0F1F5", padding: "7px 14px", display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" },
  timeBig: { fontSize: 16, fontWeight: 700, color: "#1a1a2e" },
  timeSub: { fontSize: 10, color: "#9295A4" },
  priceAmt: { fontSize: 18, fontWeight: 700, color: "#1a1a2e" },
  priceSub: { fontSize: 10, color: "#9295A4", marginBottom: 2 },
  bookBtn: { background: "#1a73e8", color: "#fff", border: "none", borderRadius: 7, padding: "6px 14px", fontSize: 12, fontWeight: 600, cursor: "pointer", marginTop: 5 },
  badgeGreen: { background: "#E6F4EA", color: "#27600A", padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 500 },
  badgeGray: { background: "#F0F1F5", color: "#6B6F80", padding: "2px 8px", borderRadius: 20, fontSize: 11 },
  badgeAmber: { background: "#FFF3E0", color: "#854F0B", padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 500 },
  tripLabel: { fontSize: 10, fontWeight: 600, padding: "1px 7px", borderRadius: 4, marginBottom: 2, display: "inline-block" },
  logoBox: { width: 34, height: 34, borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0 },
  logoImg: { width: "100%", height: "100%", objectFit: "contain" },
  loadingMore: { textAlign: "center", padding: "16px 0", color: "#9295A4", fontSize: 12 },
};

const LOGO_COLORS = ["#D0021B","#1a73e8","#FF6600","#6B21A8","#059669","#e91e63","#0097A7","#F57C00"];
const AIRLINES_LIST = ["Air India","Indigo","SpiceJet","Vistara","GoFirst","Air Asia","Saudi Arabian Airlines","Emirates","Etihad"];

// ====================== SMALL ICON GLYPHS (for ModifyPanel) ======================
const IconPlane = ({ style }) => (
  <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor" style={style} aria-hidden="true">
    <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2.5 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
  </svg>
);
const IconCalendar = () => (
  <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const IconUsers = () => (
  <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const IconSwap = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M7 16V4M7 4L3 8M7 4l4 4" /><path d="M17 8v12m0 0l4-4m-4 4l-4-4" />
  </svg>
);
const IconSearch = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.3-4.3" />
  </svg>
);
const IconFilter = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </svg>
);
const IconRupee = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 3h12M6 8h12M6 13l8.5 8M6 13h3c3 0 5-1.5 5-5" />
  </svg>
);
const IconStops = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
  </svg>
);
const IconClock = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);
const IconAirlineTag = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.5 3.5L18 11l3 3v3l-6-2-2 5-1.5-1.5L13 15l-8-2.5V10l4 1L11.5 3l1.5 1.5L11 8l3 1z" />
  </svg>
);
// ✅ Shared airport-loading helper — same pattern/endpoints as the homepage,
// with fallbacks so it works regardless of which route the user lands on first.
async function loadAirportsShared(setAirports) {
  const stored = localStorage.getItem("airports");
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        setAirports(parsed);
        return;
      }
    } catch (e) {
      localStorage.removeItem("airports");
    }
  }

  // Try #1: env/proxy based endpoint (same as homepage's second effect)
  try {
    const AIRPORTS_ENDPOINT = process.env.NODE_ENV === "development"
      ? "/api/Air/Airports"
      : `${process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_FLIGHTS_API_URL}/Air/Airports`;

    const res = await fetch(AIRPORTS_ENDPOINT, {
      method: "GET",
      headers: { Accept: "application/json" },
    });
    if (res.ok) {
      const data = await res.json();
      const arr = Array.isArray(data) ? data : (data?.data && Array.isArray(data.data) ? data.data : []);
      if (arr.length > 0) {
        setAirports(arr);
        localStorage.setItem("airports", JSON.stringify(arr));
        return;
      }
    } 
  } catch (err) {
    console.warn("Airport GET fetch failed, trying POST fallback:", err.message);
  }

  // Try #2: hardcoded POST endpoint (same as homepage's first effect)
  try {
    const res = await fetch("https://api.livev1.fly24hrs.com/api/Air/Airports", {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({}),
    });
    if (res.ok) {
      const data = await res.json();
      const arr = Array.isArray(data) ? data : (data?.data && Array.isArray(data.data) ? data.data : []);
      if (arr.length > 0) {
        setAirports(arr);
        localStorage.setItem("airports", JSON.stringify(arr));
        return;
      }
    }
  } catch (err) {
    console.error("Airport POST fallback also failed:", err.message);
  }
}

function AirlineLogo({ airlineCode, bgColor, textColor, initials }) {
  const [imgError, setImgError] = useState(false);
  const fileName = getLogoFileName(airlineCode);

  if (imgError || !airlineCode) {
    return (
      <div style={{ ...S.logoBox, background: bgColor + "22", color: textColor, fontSize: 10, fontWeight: 700 }}>
        {initials}
      </div>
    );
  }

  return (
    <div style={{ ...S.logoBox, background: "#fff", border: "1px solid #F0F1F5" }}>
      <img
        src={`/Flight_Images/${fileName}.gif`}
        alt={airlineCode}
        style={S.logoImg}
        onError={() => setImgError(true)}
      />
    </div>
  );
}

// ====================== MODIFY PANEL (redesigned) ======================
function ModifyPanel({ tripType, setTripType, navigate, searchData }) {
  const firstRoute = searchData?.Routs?.[0];
  const secondRoute = searchData?.Routs?.[1];
const CLASS_NAMES_REVERSE = {
  0: "Economy",
  1: "Premium Economy",
  2: "Business",
  3: "First Class",
};
  const initialFrom = {
    city: firstRoute?.InputSource?.split(" - ")[1] || firstRoute?.Source || "",
    code: firstRoute?.Source || "",
    name: firstRoute?.InputSource?.split(" - ")[1] || "",
  };
  const initialTo = {
    city: firstRoute?.OutputSource?.split(" - ")[1] || firstRoute?.Destination || "",
    code: firstRoute?.Destination || "",
    name: firstRoute?.OutputSource?.split(" - ")[1] || "",
  };

  const [from, setFrom] = useState(initialFrom);
  const [to, setTo] = useState(initialTo);
  const [fromQuery, setFromQuery] = useState(initialFrom.city);
  const [toQuery, setToQuery] = useState(initialTo.city);
  const [fromSuggestions, setFromSuggestions] = useState([]);
  const [toSuggestions, setToSuggestions] = useState([]);
  const [airports, setAirports] = useState([]);
  const [departDate, setDepartDate] = useState(firstRoute?.TravelDate || "");
  const [returnDate, setReturnDate] = useState(secondRoute?.TravelDate || "");
  const [adults, setAdults] = useState(searchData?.AdultCount || 1);
  const [children, setChildren] = useState(searchData?.ChildCount || 0);
  const [infants, setInfants] = useState(searchData?.InfantCount || 0);
  const [travelClass, setTravelClass] = useState(
  CLASS_NAMES_REVERSE[searchData?.TypeOfClass] || "Economy"
);  
  const [showTravelerDropdown, setShowTravelerDropdown] = useState(false);

  const fromRef = useRef(null);
  const toRef = useRef(null);
  const travelerRef = useRef(null);
  const departInputRef = useRef(null);
  const returnInputRef = useRef(null);

  useEffect(() => {
    setFrom(initialFrom);
    setTo(initialTo);
    setFromQuery(initialFrom.city);
    setToQuery(initialTo.city);
    setDepartDate(firstRoute?.TravelDate || "");
    setReturnDate(secondRoute?.TravelDate || "");
    setAdults(searchData?.AdultCount || 1);
    setChildren(searchData?.ChildCount || 0);
    setInfants(searchData?.InfantCount || 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  useEffect(() => {
    loadAirportsShared(setAirports);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (fromRef.current && !fromRef.current.contains(e.target)) setFromSuggestions([]);
      if (toRef.current && !toRef.current.contains(e.target)) setToSuggestions([]);
      if (travelerRef.current && !travelerRef.current.contains(e.target)) setShowTravelerDropdown(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (searchData?.TripType === 1 || (searchData?.Routs?.length || 0) > 1) {
      setTripType("Round trip");
    } else {
      setTripType("One way");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  const getFilteredAirports = (query) => {
    if (!Array.isArray(airports)) return [];
    const q = (query || "").trim().toLowerCase();
    return airports.filter(a =>
      (a.CityName && a.CityName.toLowerCase().includes(q)) ||
      (a.AirportCode && a.AirportCode.toLowerCase().includes(q)) ||
      (a.AirportName && a.AirportName.toLowerCase().includes(q))
    );
  };

  const handleFromChange = (e) => {
    const value = e.target.value;
    setFromQuery(value);
    setFromSuggestions(value.trim().length >= 3 ? getFilteredAirports(value).slice(0, 10) : []);
  };

  const handleToChange = (e) => {
    const value = e.target.value;
    setToQuery(value);
    setToSuggestions(value.trim().length >= 3 ? getFilteredAirports(value).slice(0, 10) : []);
  };

  const handleFromFocus = () => {
    if (fromQuery.trim().length >= 3) setFromSuggestions(getFilteredAirports(fromQuery).slice(0, 10));
  };
  const handleToFocus = () => {
    if (toQuery.trim().length >= 3) setToSuggestions(getFilteredAirports(toQuery).slice(0, 10));
  };

  const selectFromAirport = (a) => {
    setFrom({ city: a.CityName, code: a.AirportCode, name: a.AirportName });
    setFromQuery(a.CityName);
    setFromSuggestions([]);
  };

  const selectToAirport = (a) => {
    setTo({ city: a.CityName, code: a.AirportCode, name: a.AirportName });
    setToQuery(a.CityName);
    setToSuggestions([]);
  };

  const handleSwap = () => {
    const tf = from, tt = to;
    setFrom(tt); setTo(tf);
    setFromQuery(tt.city); setToQuery(tf.city);
  };

  const fmtDateDisplay = (dateStr) => {
    if (!dateStr) return null;
    const dt = new Date(dateStr);
    if (isNaN(dt.getTime())) return null;
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const days = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
    return { day: dt.getDate(), month: months[dt.getMonth()], year: dt.getFullYear(), dayName: days[dt.getDay()] };
  };
  const departDisp = fmtDateDisplay(departDate);
  const returnDisp = fmtDateDisplay(returnDate);
  const totalTravelers = adults + children + infants;

  const CLASS_MAP = { "Economy": 0, "Premium Economy": 1, "Business": 2, "First Class": 3 };

  const handleSearch = () => {
    const routs = [{
      Source: from.code,
      InputSource: `${from.code} - ${from.name}`,
      Destination: to.code,
      OutputSource: `${to.code} - ${to.name}`,
      TravelDate: departDate,
    }];
    if (tripType === "Round trip") {
      routs.push({
        Source: to.code,
        InputSource: `${to.code} - ${to.name}`,
        Destination: from.code,
        OutputSource: `${from.code} - ${from.name}`,
        TravelDate: returnDate,
      });
    }
    const payload = {
      APIToken: null,
      AgencyKey: "4AC0F2DD-66C2-4AC1-8AFD-DE615E223A4A",
      AdultCount: Number(adults) || 1,
      ChildCount: Number(children) || 0,
      InfantCount: Number(infants) || 0,
      PreferredAirlines: null,
      Routs: routs,
      TripType: tripType === "Round trip" ? 1 : 0,
      TypeOfClass: CLASS_MAP[travelClass] ?? 0,
      IsDomestic: true,
      SetAirport: null,
      IsB2B: false,
      IsSpecailFlight: false,
      FromCity: null,
      Tocity: null,
      TransactionId: 0,
      EngineType: 0,
      AccountNo: 17,
    };
    navigate("/AirResponse/Index", { state: { searchData: payload } });
  };

  return (
    <div className="mp-panel">
      <div className="mp-triptype" role="tablist" aria-label="Trip type">
        {["One way", "Round trip"].map((t) => (
          <button
            key={t}
            type="button"
            role="tab"
            aria-selected={tripType === t}
            className={`mp-trip-btn${tripType === t ? " active" : ""}`}
            onClick={() => setTripType(t)}
          >
            {t}
          </button>
        ))}
      </div>

      <div className="mp-fields">
        {/* FROM */}
        <div className="mp-field mp-field-route" ref={fromRef}>
          <label className="mp-label"><IconPlane style={{ transform: "rotate(45deg)" }} /> From</label>
          <input
            className="mp-input"
            value={fromQuery}
            onChange={handleFromChange}
            onFocus={handleFromFocus}
            autoComplete="off"
            placeholder="City or airport"
          />
          <span className="mp-sub">{from.code} · {from.name}</span>

          {fromSuggestions.length > 0 && (
            <ul className="mp-suggestions">
              {fromSuggestions.map((a, i) => (
                <li key={a.ID || i} onClick={() => selectFromAirport(a)}>
                  <span className="mp-sugg-main">{a.CityName} <span className="mp-sugg-code">{a.AirportCode}</span></span>
                  <span className="mp-sugg-sub">{a.AirportName}</span>
                </li>
              ))}
            </ul>
          )}

          <button type="button" className="mp-swap" onClick={handleSwap} aria-label="Swap origin and destination">
            <IconSwap />
          </button>
        </div>

        {/* TO */}
        <div className="mp-field mp-field-route" ref={toRef}>
          <label className="mp-label"><IconPlane style={{ transform: "rotate(135deg)" }} /> To</label>
          <input
            className="mp-input"
            value={toQuery}
            onChange={handleToChange}
            onFocus={handleToFocus}
            autoComplete="off"
            placeholder="City or airport"
          />
          <span className="mp-sub">{to.code} · {to.name}</span>

          {toSuggestions.length > 0 && (
            <ul className="mp-suggestions">
              {toSuggestions.map((a, i) => (
                <li key={a.ID || i} onClick={() => selectToAirport(a)}>
                  <span className="mp-sugg-main">{a.CityName} <span className="mp-sugg-code">{a.AirportCode}</span></span>
                  <span className="mp-sugg-sub">{a.AirportName}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* DEPART */}
        <div className="mp-field mp-field-date" onClick={() => departInputRef.current?.showPicker?.()}>
          <label className="mp-label"><IconCalendar /> Departure</label>
          <input
            ref={departInputRef}
            type="date"
            className="mp-date-input"
            value={departDate}
            onChange={(e) => setDepartDate(e.target.value)}
          />
          {departDisp ? (
            <div className="mp-date-display">
              <span className="mp-date-day">{departDisp.day}</span>
              <span className="mp-date-month">{departDisp.month} {departDisp.year}</span>
            </div>
          ) : (
            <div className="mp-date-placeholder">Select date</div>
          )}
          <span className="mp-sub">{departDisp?.dayName || "\u00A0"}</span>
        </div>

        {/* RETURN */}
        <div
          className={`mp-field mp-field-date${tripType !== "Round trip" ? " mp-disabled" : ""}`}
          onClick={() => tripType === "Round trip" && returnInputRef.current?.showPicker?.()}
        >
          <label className="mp-label"><IconCalendar /> Return</label>
          <input
            ref={returnInputRef}
            type="date"
            className="mp-date-input"
            value={returnDate}
            disabled={tripType !== "Round trip"}
            min={departDate}
            onChange={(e) => setReturnDate(e.target.value)}
          />
          {tripType === "Round trip" && returnDisp ? (
            <div className="mp-date-display">
              <span className="mp-date-day">{returnDisp.day}</span>
              <span className="mp-date-month">{returnDisp.month} {returnDisp.year}</span>
            </div>
          ) : (
            <div className="mp-date-placeholder">{tripType === "Round trip" ? "Select date" : "One way trip"}</div>
          )}
          <span className="mp-sub">{(tripType === "Round trip" && returnDisp?.dayName) || "\u00A0"}</span>
        </div>

        <div className="mp-field mp-field-travelers" ref={travelerRef} onClick={() => setShowTravelerDropdown(v => !v)}>
          <label className="mp-label"><IconUsers /> Travellers &amp; class</label>
          <div className="mp-date-display">
            <span className="mp-date-day">{totalTravelers}</span>
            <span className="mp-date-month">Traveller{totalTravelers > 1 ? "s" : ""}</span>
          </div>
          <span className="mp-sub">{travelClass}</span>

          {showTravelerDropdown && (
            <div className="mp-traveler-dropdown" onClick={(e) => e.stopPropagation()}>
              {[
                { label: "Adults", sub: "12+ yrs", val: adults, set: setAdults },
                { label: "Children", sub: "2–12 yrs", val: children, set: setChildren },
                { label: "Infants", sub: "Under 2 yrs", val: infants, set: setInfants },
              ].map((item, idx) => {
                const isAdultOrChild = item.label === "Adults" || item.label === "Children";
                const canIncrease = isAdultOrChild ? (adults + children < 9) : (infants < 9);
                const canDecrease = item.label === "Adults" ? item.val > 1 : item.val > 0;

                return (
                  <div key={idx} className="mp-traveler-row">
                    <div>
                      <div className="mp-traveler-label">{item.label}</div>
                      <div className="mp-traveler-sub">{item.sub}</div>
                    </div>
                    <div className="mp-stepper">
                      <button type="button" disabled={!canDecrease} onClick={() => item.set(item.val - 1)}>&minus;</button>
                      <span>{item.val}</span>
                      <button type="button" disabled={!canIncrease} onClick={() => item.set(item.val + 1)}>+</button>
                    </div>
                  </div>
                );
              })}

              <div className="mp-class-section">
                <div className="mp-class-title">Travel class</div>
                <div className="mp-class-grid">
                  {["Economy", "Premium Economy", "Business", "First Class"].map((cls) => (
                    <button
                      key={cls}
                      type="button"
                      className={`mp-class-btn${travelClass === cls ? " active" : ""}`}
                      onClick={() => setTravelClass(cls)}
                    >
                      {cls}
                    </button>
                  ))}
                </div>
              </div>

              <button type="button" className="mp-done-btn" onClick={() => setShowTravelerDropdown(false)}>
                Done
              </button>
            </div>
          )}
        </div>

        {/* SEARCH */}
        <div className="mp-field mp-field-submit">
          <button type="button" className="mp-search-btn" onClick={handleSearch}>
            <IconSearch /> Search
          </button>
        </div>
      </div>

      <style>{`
  .mp-panel {
    --mp-navy: #0B1D45;
    --mp-navy-deep: #071530;
    --mp-sky: #1a73e8;
    --mp-accent: #e91e63;
    --mp-accent-soft: #fff0f5;
    --mp-ink: #14213D;
    --mp-muted: #6B7280;
    --mp-border: #E5E7EB;
    --mp-bg: #F8FAFC;
    --mp-white: #ffffff;
    --mp-shadow: 0 10px 40px rgba(11, 29, 69, 0.12);
    
    background: var(--mp-white);
    border-bottom: 1px solid var(--mp-border);
    padding: 20px 24px 24px;
    max-width: 1147px;
    margin: 0 auto;
    box-shadow: var(--mp-shadow);
  }

  /* Trip Type Toggle */
  .mp-triptype {
    display: inline-flex;
    background: var(--mp-bg);
    border-radius: 12px;
    padding: 4px;
    margin-bottom: 18px;
    gap: 4px;
    border: 1px solid var(--mp-border);
  }
  .mp-trip-btn {
    border: none;
    background: transparent;
    padding: 9px 22px;
    border-radius: 9px;
    font-size: 13.5px;
    font-weight: 600;
    color: var(--mp-muted);
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: inherit;
  }
  .mp-trip-btn.active {
    background: var(--mp-navy);
    color: #fff;
    box-shadow: 0 4px 14px rgba(11, 29, 69, 0.3);
  }
  .mp-trip-btn:hover:not(.active) {
    color: var(--mp-ink);
    background: rgba(11, 29, 69, 0.05);
  }

  /* Fields Grid */
  .mp-fields {
    display: grid;
    grid-template-columns: 1.35fr 1.35fr 1fr 1fr 1.2fr auto;
    border: 1px solid var(--mp-border);
    border-radius: 16px;
    overflow: visible;
    background: var(--mp-white);
    box-shadow: 0 2px 12px rgba(11, 29, 69, 0.04);
  }

  .mp-field {
    position: relative;
    padding: 14px 18px;
    border-right: 1px solid var(--mp-border);
    transition: background 0.15s ease;
  }
  .mp-field:last-child { border-right: none; }
  .mp-field:not(.mp-field-submit):hover {
    background: #FAFBFF;
  }
  .mp-field.mp-disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .mp-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--mp-muted);
    margin-bottom: 6px;
  }
  .mp-label svg { flex-shrink: 0; opacity: 0.7; }

  .mp-input {
    border: none;
    outline: none;
    width: 100%;
    font-size: 17px;
    font-weight: 700;
    color: var(--mp-ink);
    background: transparent;
    padding: 0;
    font-family: inherit;
  }
  .mp-input::placeholder {
    color: #B0B7C3;
    font-weight: 500;
  }

  .mp-sub {
    display: block;
    font-size: 11.5px;
    color: var(--mp-muted);
    margin-top: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Swap Button */
  .mp-swap {
    position: absolute;
    right: -15px;
    top: 42px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: var(--mp-navy);
    color: #fff;
    border: 3px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 5;
    box-shadow: 0 4px 12px rgba(11, 29, 69, 0.35);
    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  .mp-swap:hover {
    transform: rotate(180deg);
  }

  /* Suggestions */
  .mp-suggestions {
    position: absolute;
    top: calc(100% + 8px);
    left: 8px;
    right: 8px;
    z-index: 60;
    background: #fff;
    border: 1px solid var(--mp-border);
    border-radius: 14px;
    list-style: none;
    margin: 0;
    padding: 8px;
    max-height: 280px;
    overflow-y: auto;
    box-shadow: 0 16px 40px rgba(11, 29, 69, 0.18);
  }
  .mp-suggestions li {
    cursor: pointer;
    padding: 10px 12px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    transition: background 0.15s ease;
  }
  .mp-suggestions li:hover {
    background: var(--mp-bg);
  }
  .mp-sugg-main {
    font-size: 14px;
    font-weight: 600;
    color: var(--mp-ink);
  }
  .mp-sugg-code {
    color: var(--mp-sky);
    font-weight: 700;
  }
  .mp-sugg-sub {
    font-size: 12px;
    color: var(--mp-muted);
  }

  /* Date fields */
  .mp-field-date { cursor: pointer; }
  .mp-date-input {
    position: absolute;
    inset: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .mp-date-display {
    display: flex;
    align-items: baseline;
    gap: 6px;
  }
  .mp-date-day {
    font-size: 22px;
    font-weight: 700;
    color: var(--mp-ink);
  }
  .mp-date-month {
    font-size: 13px;
    font-weight: 600;
    color: var(--mp-muted);
  }
  .mp-date-placeholder {
    font-size: 15px;
    font-weight: 600;
    color: #B0B7C3;
    padding-top: 2px;
  }

  /* Travellers dropdown */
  .mp-field-travelers { cursor: pointer; }
  .mp-traveler-dropdown {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    z-index: 70;
    background: #fff;
    border: 1px solid var(--mp-border);
    border-radius: 16px;
    box-shadow: 0 20px 50px rgba(11, 29, 69, 0.2);
    width: 320px;
    padding: 20px;
    cursor: default;
  }
  .mp-traveler-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
  }
  .mp-traveler-label {
    font-size: 14.5px;
    font-weight: 600;
    color: var(--mp-ink);
  }
  .mp-traveler-sub {
    font-size: 12.5px;
    color: var(--mp-muted);
  }
  .mp-stepper {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .mp-stepper button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1.5px solid var(--mp-border);
    background: #fff;
    color: var(--mp-navy);
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
  }
  .mp-stepper button:hover:not(:disabled) {
    background: var(--mp-navy);
    color: #fff;
    border-color: var(--mp-navy);
  }
  .mp-stepper button:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
  .mp-stepper span {
    min-width: 20px;
    text-align: center;
    font-weight: 700;
    font-size: 15px;
    color: var(--mp-ink);
  }

  /* Class section */
  .mp-class-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--mp-border);
  }
  .mp-class-title {
    font-size: 13.5px;
    font-weight: 700;
    color: var(--mp-ink);
    margin-bottom: 12px;
  }
  .mp-class-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .mp-class-btn {
    padding: 10px;
    border-radius: 10px;
    border: 1.5px solid var(--mp-border);
    background: #fff;
    font-size: 13px;
    font-weight: 600;
    color: var(--mp-ink);
    cursor: pointer;
    transition: all 0.15s ease;
    font-family: inherit;
  }
  .mp-class-btn.active {
    background: var(--mp-navy);
    border-color: var(--mp-navy);
    color: #fff;
    box-shadow: 0 4px 12px rgba(11, 29, 69, 0.25);
  }
  .mp-class-btn:hover:not(.active) {
    border-color: var(--mp-navy);
    background: #F0F4FF;
  }

  .mp-done-btn {
    margin-top: 18px;
    width: 100%;
    padding: 12px;
    border: none;
    border-radius: 10px;
    background: var(--mp-navy);
    color: #fff;
    font-size: 14.5px;
    font-weight: 700;
    cursor: pointer;
    font-family: inherit;
    transition: background 0.15s ease;
  }
  .mp-done-btn:hover {
    background: var(--mp-navy-deep);
  }

  /* Search Button */
  .mp-field-submit {
    padding: 12px;
    display: flex;
    align-items: center;
  }
  .mp-search-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 54px;
    padding: 0 28px;
    border: none;
    border-radius: 12px;
    background: linear-gradient(135deg, #e91e63, #c2185b);
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
    box-shadow: 0 8px 24px rgba(233, 30, 99, 0.35);
    transition: all 0.2s ease;
    font-family: inherit;
  }
  .mp-search-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(233, 30, 99, 0.45);
  }

  .mp-field-route:focus-within,
  .mp-field-date:focus-within {
    box-shadow: inset 0 0 0 2px rgba(26, 115, 232, 0.18);
  }

  /* Responsive */
  @media (max-width: 1024px) {
    .mp-fields {
      grid-template-columns: 1fr 1fr;
    }
    .mp-field {
      border-right: none;
      border-bottom: 1px solid var(--mp-border);
    }
    .mp-field:last-child { border-bottom: none; }
    .mp-field-submit { grid-column: 1 / -1; }
    .mp-search-btn { width: 100%; }
    .mp-swap {
      right: 12px;
      top: -14px;
    }
  }
  @media (max-width: 560px) {
    .mp-fields { grid-template-columns: 1fr; }
    .mp-traveler-dropdown {
      right: auto;
      left: 0;
      width: 100%;
    }
    .mp-panel { padding: 16px; }
  }
`}</style>
    </div>
  );
}

// ✅ FIXED: FilterPanel ab priceRange prop leta hai (dynamic min/max, aedRate ke hisaab se)
function FilterPanel({ filters, setFilters, availableAirlines, priceRange, aedRate }) {
  const [openSecs, setOpenSecs] = useState({ price: true, stops: true, time: true, airlines: true , refundable: true});

  const toggle = (key, val) =>
    setFilters((f) => ({ ...f, [key]: f[key].includes(val) ? f[key].filter((x) => x !== val) : [...f[key], val] }));

  // ✅ Reset ab dynamic max price pe jaata hai, hardcoded 300000 pe nahi
  const resetAll = () => setFilters({ maxPrice: priceRange.max, stops: [], depSlots: [], airlines: [] , refundable: [], });
  const toggleSec = (sec) => setOpenSecs((s) => ({ ...s, [sec]: !s[sec] }));

  const activeCount = filters.stops.length + filters.depSlots.length + filters.airlines.length;

  // Card AED mein price dikhata hai, isliye filter label bhi AED symbol use karega jab rate available ho
  const currencySymbol = aedRate ? "\u00ea " : "\u20b9";
  const fmt = (val) => (aedRate ? val.toFixed(2) : Math.round(val).toLocaleString("en-IN"));

  return (
    <div style={S.filterCard}>
      {/* Header */}
      <div style={S.filterHead}>
        <span style={S.filterHeadTitle}><IconFilter /> Filters{activeCount > 0 && (
          <span style={{ background: "#e91e63", color: "#fff", fontSize: 10, fontWeight: 700, borderRadius: 20, padding: "1px 7px" }}>
            {activeCount}
          </span>
        )}</span>
        <button style={S.resetLink} onClick={resetAll}>↺ Reset</button>
      </div>

      {/* Price */}
      <div style={S.filterSec}>
        <div style={S.filterSecHead} onClick={() => toggleSec("price")}>
          <span style={S.filterTitle}><IconRupee /> Price</span>
          <span style={{ ...S.chevron, transform: openSecs.price ? "rotate(180deg)" : "rotate(0deg)" }}>▼</span>
        </div>
        {openSecs.price && (
          <>
            <input
              type="range"
              min={priceRange.min}
              max={priceRange.max}
              step={priceRange.max > priceRange.min ? (priceRange.max - priceRange.min) / 100 : 1}
              value={filters.maxPrice}
              onChange={(e) => setFilters((f) => ({ ...f, maxPrice: +e.target.value }))}
              style={{ width: "100%", accentColor: "#1a73e8" }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
              <span style={{ fontSize: 10.5, color: "#9295A4", fontWeight: 500 }}>
                {currencySymbol}{fmt(priceRange.min)}
              </span>
              <span style={{
                fontSize: 12, color: "#1a73e8", fontWeight: 700, background: "#E8F0FE",
                padding: "3px 10px", borderRadius: 20,
              }}>
                {currencySymbol}{fmt(filters.maxPrice)}
              </span>
            </div>
          </>
        )}
      </div>

      {/* Stops */}
      <div style={S.filterSec}>
        <div style={S.filterSecHead} onClick={() => toggleSec("stops")}>
          <span style={S.filterTitle}><IconStops /> Stops</span>
          <span style={{ ...S.chevron, transform: openSecs.stops ? "rotate(180deg)" : "rotate(0deg)" }}>▼</span>
        </div>
        {openSecs.stops && (
          <div style={S.stopBtns}>
            {[0, 1, 2].map((s) => {
              const active = filters.stops.includes(s);
              return (
                <div
                  key={s}
                  onClick={() => toggle("stops", s)}
                  style={{
                    flex: 1,
                    padding: "9px 4px",
                    border: `1.5px solid ${active ? "#1a73e8" : "#E8EAF0"}`,
                    borderRadius: 10,
                    fontSize: 12,
                    textAlign: "center",
                    cursor: "pointer",
                    background: active ? "linear-gradient(135deg, #1a73e8, #4a90f0)" : "#fff",
                    color: active ? "#fff" : "#6B6F80",
                    fontWeight: active ? 700 : 500,
                    transition: "all .18s ease",
                    boxShadow: active ? "0 4px 10px rgba(26,115,232,.3)" : "none",
                  }}
                >
                  <div style={{ fontSize: 15, fontWeight: 700 }}>{s === 2 ? "1+" : s}</div>
                  <div style={{ fontSize: 9.5 }}>stop</div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Departure time */}
      <div style={S.filterSec}>
        <div style={S.filterSecHead} onClick={() => toggleSec("time")}>
          <span style={S.filterTitle}><IconClock /> Departure time</span>
          <span style={{ ...S.chevron, transform: openSecs.time ? "rotate(180deg)" : "rotate(0deg)" }}>▼</span>
        </div>
        {openSecs.time && [
          ["Early morning", "12–6 AM", 1],
          ["Morning", "6–12 PM", 2],
          ["Afternoon", "12–6 PM", 3],
          ["Evening", "6–12 AM", 4],
        ].map(([lbl, range, slot]) => {
          const active = filters.depSlots.includes(slot);
          return (
            <label
              key={slot}
              style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                padding: "7px 8px", fontSize: 12.5, cursor: "pointer", borderRadius: 8,
                background: active ? "#F0F4FF" : "transparent", marginBottom: 2, transition: "background .15s ease",
              }}
            >
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <input
                  type="checkbox"
                  checked={active}
                  onChange={() => toggle("depSlots", slot)}
                  style={{ accentColor: "#1a73e8", width: 14, height: 14 }}
                />
                <span style={{ fontWeight: active ? 600 : 500, color: active ? "#1a1a2e" : "#3a3d4a" }}>{lbl}</span>
              </span>
              <span style={{ fontSize: 10.5, color: "#9295A4" }}>{range}</span>
            </label>
          );
        })}
      </div>

      {/* Airlines */}
   <div style={{ ...S.filterSec, borderBottom: "none" }}>
  <div style={S.filterSecHead} onClick={() => toggleSec("airlines")}>
    <span style={S.filterTitle}><IconAirlineTag /> Airlines</span>
    <span style={{ ...S.chevron, transform: openSecs.airlines ? "rotate(180deg)" : "rotate(0deg)" }}>▼</span>
  </div>
  {openSecs.airlines && availableAirlines.map((a) => {
    const active = filters.airlines.includes(a.code);
    return (
      <label
        key={a.code}
        style={{
          display: "flex", alignItems: "center", gap: 8,
          padding: "7px 8px", fontSize: 12.5, cursor: "pointer", borderRadius: 8,
          background: active ? "#F0F4FF" : "transparent", marginBottom: 2, transition: "background .15s ease",
        }}
      >
        <div style={{ ...S.logoBox, background: "#fff", border: "1px solid #F0F1F5" }}>
          <img
            src={`/Flight_Images/${a.code}.gif`}
            alt={a.code}
            style={S.logoImg}
            onError={(e) => {
              e.target.style.display = "none"; // hide broken image
            }}
          />
        </div>
        <input
          type="checkbox"
          checked={active}
          onChange={() => toggle("airlines", a.code)}
          style={{ accentColor: "#1a73e8", width: 14, height: 14 }}
        />
        <span style={{ fontWeight: active ? 600 : 500, color: active ? "#1a1a2e" : "#3a3d4a" }}>
          {a.name} <span style={{ color: "#9295A4", fontWeight: 500 }}>({a.code})</span>
        </span>
      </label>
    );
 
 })}

 {/* Refundable Filter */}
<div style={{ ...S.filterSec, borderBottom: "none" }}>
  <div style={S.filterSecHead} onClick={() => toggleSec("refundable")}>
    <span style={S.filterTitle}>Refundable</span>
    <span style={{ ...S.chevron, transform: openSecs.refundable ? "rotate(180deg)" : "rotate(0deg)" }}>
      ▼
    </span>
  </div>

  {openSecs.refundable && (
    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {[
        { label: "Refundable", value: true },
        { label: "Non-Refundable", value: false },
      ].map(({ label, value }) => {
        const active = filters.refundable.includes(value);
        return (
          <label
            key={String(value)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "7px 8px",
              fontSize: 12.5,
              cursor: "pointer",
              borderRadius: 8,
              background: active ? "#F0F4FF" : "transparent",
              marginBottom: 2,
              transition: "background .15s ease",
            }}
          >
            <input
              type="checkbox"
              checked={active}
              onChange={() => toggle("refundable", value)}
              style={{ accentColor: "#1a73e8", width: 14, height: 14 }}
            />
            <span style={{ fontWeight: active ? 600 : 500, color: active ? "#1a1a2e" : "#3a3d4a" }}>
              {label}
            </span>
          </label>
        );
      })}
    </div>
  )}
</div>
</div>
    </div>
  );
}
function FlightCard({ flight, index, sessionData, isDomestic, searchData, passengersArray , aedRate }) {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const d = getDisplayData(flight);
  const lc = LOGO_COLORS[index % LOGO_COLORS.length];
  const priceAED = aedRate ? (d.price * aedRate).toFixed(2) : null;
  return (
    <div style={S.flightCard}>

      {/* ✅ ONWARD ROW */}
      <div style={S.flightRow}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AirlineLogo airlineCode={d.airlineCode} bgColor={lc} textColor={lc} initials={d.logo} />
          <div>
            <span style={{ ...S.tripLabel, background: "#e8f0fe", color: "#1a73e8" }}>✈ ONWARD</span>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1a2e" }}>{d.airline}</div>
            <div style={{ fontSize: 11, color: "#9295A4" }}>{d.code}</div>
          </div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={S.timeBig}>{d.dep}</div>
          <div style={S.timeSub}>{d.origin}</div>
          {d.originCity && <div style={{ fontSize: 10, color: "#9295A4" }}>{d.originCity}</div>}
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 11, color: "#9295A4" }}>{formatDur(d.durMin)}</div>
          <div style={{ position: "relative", margin: "4px 0" }}>
            <div style={{ height: 1, background: "#D0D3E0", position: "relative" }}>
              <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#D0D3E0", position: "absolute", top: -2, left: 0 }} />
              <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#D0D3E0", position: "absolute", top: -2, right: 0 }} />
            </div>
          </div>
          <span style={d.stops === 0 ? S.badgeGreen : S.badgeAmber}>
            {d.stops === 0 ? "Non-stop" : `${d.stops} stop`}
          </span>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={S.timeBig}>{d.arr}</div>
          <div style={S.timeSub}>{d.dest}</div>
          {d.destCity && <div style={{ fontSize: 10, color: "#9295A4" }}>{d.destCity}</div>}
        </div>
       <div style={{ textAlign: "right" }}>
  <div style={S.priceSub}>per person</div>
  {priceAED && (
    <div style={S.priceAmt}>
      <span style={{ fontFamily: "sans-serif" }}>&#xea;</span> {priceAED}
    
    </div>
  )}


        <button
  style={S.bookBtn}
  onClick={() =>
    navigate("/FareDetails", {
      state: {
        flight,
        apiToken:   sessionData?.apiToken,
        agencyKey:  sessionData?.agencyKey,
        bookingKey: sessionData?.bookingKey,
        IsDomestic: isDomestic,
        passengers: passengersArray,
        AdultCount:  searchData?.AdultCount  || 1,
        ChildCount:  searchData?.ChildCount  || 0,
        InfantCount: searchData?.InfantCount || 0,
      }
    })
  }
>
  Book now
</button>
        </div>
      </div>

      {/* ✅ RETURN ROW — sirf round trip mein */}
      {d.isRoundTrip && (
        <div style={S.returnRow}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <AirlineLogo airlineCode={d.retAirlineCode} bgColor={lc} textColor={lc} initials={d.logo} />
            <div>
              <span style={{ ...S.tripLabel, background: "#fce4ec", color: "#c2185b" }}>↩ RETURN</span>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1a2e" }}>{d.airline}</div>
              <div style={{ fontSize: 11, color: "#9295A4" }}>{d.code}</div>
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={S.timeBig}>{d.retDep}</div>
            <div style={S.timeSub}>{d.retOrigin}</div>
            {d.retOriginCity && <div style={{ fontSize: 10, color: "#9295A4" }}>{d.retOriginCity}</div>}
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 11, color: "#9295A4" }}>{formatDur(d.retDurMin)}</div>
            <div style={{ position: "relative", margin: "4px 0" }}>
              <div style={{ height: 1, background: "#D0D3E0" }}>
                <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#D0D3E0", position: "absolute", top: -2, left: 0 }} />
                <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#D0D3E0", position: "absolute", top: -2, right: 0 }} />
              </div>
            </div>
            <span style={d.retStops === 0 ? S.badgeGreen : S.badgeAmber}>
              {d.retStops === 0 ? "Non-stop" : `${d.retStops} stop`}
            </span>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={S.timeBig}>{d.retArr}</div>
            <div style={S.timeSub}>{d.retDest}</div>
            {d.retDestCity && <div style={{ fontSize: 10, color: "#9295A4" }}>{d.retDestCity}</div>}
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 11, color: "#6B6F80", fontWeight: 500 }}>Round Trip</div>
            <div style={{ fontSize: 10, color: "#9295A4" }}>Incl. in fare</div>
          </div>
        </div>
      )}

      {/* Detail Bar */}
      <div style={S.detailBar}>
        <span style={S.badgeGray}>🧳 {d.baggage}</span>
        <span style={S.badgeGray}>💼 {d.handBag}</span>
        {d.isRoundTrip && <span style={{ ...S.badgeGray, background: "#fce4ec", color: "#c2185b" }}>Round Trip</span>}
        <span
          onClick={() => setExpanded(v => !v)}
          style={{ marginLeft: "auto", fontSize: 11, color: "#1a73e8", cursor: "pointer", fontWeight: 500 }}
        >
          {expanded ? "▲ Hide details" : "▼ Flight details"}
        </span>
      </div>

      {/* Expanded details */}
      {expanded && (
        <div style={{ padding: "10px 14px", background: "#F9FAFB", borderTop: "1px solid #F0F1F5", fontSize: 12, color: "#6B6F80" }}>
          <div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 8 }}>✈ Onward</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, marginBottom: d.isRoundTrip ? 12 : 0 }}>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Departs</div>{d.dep} · {d.origin}{d.originCity && <div style={{ fontSize: 11 }}>{d.originCity}</div>}</div>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Duration</div>{formatDur(d.durMin)}</div>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Arrives</div>{d.arr} · {d.dest}{d.destCity && <div style={{ fontSize: 11 }}>{d.destCity}</div>}</div>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Check-in Baggage</div>{d.baggage}</div>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Hand Baggage</div>{d.handBag}</div>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Stops</div>{d.stops === 0 ? "Non-stop" : `${d.stops} stop(s)`}</div>
          </div>
          {d.isRoundTrip && (
            <>
              <div style={{ fontWeight: 600, color: "#c2185b", marginBottom: 8, marginTop: 8, borderTop: "1px solid #f0f1f5", paddingTop: 8 }}>↩ Return</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10 }}>
                <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Departs</div>{d.retDep} · {d.retOrigin}{d.retOriginCity && <div style={{ fontSize: 11 }}>{d.retOriginCity}</div>}</div>
                <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Duration</div>{formatDur(d.retDurMin)}</div>
                <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Arrives</div>{d.retArr} · {d.retDest}{d.retDestCity && <div style={{ fontSize: 11 }}>{d.retDestCity}</div>}</div>
                <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Check-in Baggage</div>{d.retBaggage}</div>
                <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Stops</div>{d.retStops === 0 ? "Non-stop" : `${d.retStops} stop(s)`}</div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default function Index() {
  const location = useLocation();
  const navigate = useNavigate();

  const [flights, setFlights]         = useState([]);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState("");
  const [showModify, setShowModify]   = useState(false);
  const [tripType, setTripType]       = useState("One way");
  const [sortTab, setSortTab]         = useState("Best");
  // ✅ maxPrice ka initial hardcoded 300000 rehne do — flights aane ke baad
  // niche wale useEffect mein ye turant actual dynamic max se overwrite ho jaata hai.
  const [filters, setFilters]         = useState({ maxPrice: 300000, stops: [], depSlots: [], airlines: [], refundable: [] });
  const [sessionData, setSessionData] = useState({ apiToken: "", agencyKey: "", bookingKey: "" });
  const [inrToAed, setInrToAed]       = useState(null); 
  const ITEMS_PER_PAGE = 10;
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
  const isDomestic = location.state?.searchData?.IsDomestic ?? true;
  const isRoundTripSearch = (location.state?.searchData?.TripType === 1 || location.state?.searchData?.Routs?.length > 1);
const availableAirlines = useMemo(() => {
    const map = new Map();
    flights.forEach((f) => {
      const d = getDisplayData(f);
      if (d.airlineCode && !map.has(d.airlineCode)) {
        map.set(d.airlineCode, d.airline);
      }
    });
    return Array.from(map.entries())
      .map(([code, name]) => ({ code, name }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [flights]);

  // ✅ NEW: results ki actual lowest/highest price nikaalo (card jaisi currency mein — AED agar rate mil gaya, warna INR)
  const priceRange = useMemo(() => {
    const rawPrices = flights.map((f) => getDisplayData(f).price).filter((p) => p > 0);
    if (!rawPrices.length) return { min: 0, max: 300000 };

    const converted = inrToAed ? rawPrices.map((p) => p * inrToAed) : rawPrices;
    const min = Math.min(...converted);
    const max = Math.max(...converted);

    // agar min === max (sirf ek flight ya sab ek hi price) to slider ke liye thoda spread de do
    if (min === max) {
      return { min: Math.max(0, min - 1), max: max + 1 };
    }
    return { min, max };
  }, [flights, inrToAed]);

  useEffect(() => {
    const fetchRate = async () => {
      const cached = localStorage.getItem("inrToAedRate");
      const cachedAt = localStorage.getItem("inrToAedRateTime");
      const CACHE_DURATION_MS = 30 * 24 * 60 * 60 * 1000; // 30 din

      if (cached && cachedAt && Date.now() - Number(cachedAt) < CACHE_DURATION_MS) {
        setInrToAed(Number(cached));
        return;
      }

      try {
        const res = await fetch(
          `https://v6.exchangerate-api.com/v6/${process.env.REACT_APP_EXCHANGE_API_KEY}/latest/INR`
        );
        const data = await res.json();
        const rate = data?.conversion_rates?.AED;
        if (rate) {
          setInrToAed(rate);
          localStorage.setItem("inrToAedRate", rate);
          localStorage.setItem("inrToAedRateTime", Date.now().toString());
        }
      } catch (err) {
        console.error("Exchange rate fetch failed:", err.message);
      }
    };
    fetchRate();
  }, []);

  useEffect(() => {
    const sd = location.state?.searchData;
    if (sd) {
      setTripType(sd.TripType === 1 || (sd.Routs?.length || 0) > 1 ? "Round trip" : "One way");
    }
  }, [location.state]);

  useEffect(() => {
    const payload = location.state?.searchData;
    if (!payload) { navigate("/"); return; }

    const fetchFlights = async () => {
      try {
        setLoading(true);
        const baseURL = process.env.REACT_APP_FLIGHTS_API_URL;
        if (!baseURL) { setError("API configuration missing"); return; }

        const response = await fetch(`${baseURL}/Trip/AirGroupResults`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        console.log("API Response:", data);
        if (Number(data?.Error?.ErrorCode) !== 0) {
          setError(data?.Error?.ErrorDesc || "API Error");
        } else {
          setSessionData({
            apiToken:   data?.APIToken   || "",
            agencyKey:  data?.AgencyKey  || "",
            bookingKey: data?.BookingKey || "",
          });
          setFlights(data?.Contracts || []);
        }
      } catch (err) {
        console.error("Fetch Error:", err);
        setError("Server Error");
      } finally {
        setLoading(false);
      }
    };

    fetchFlights();
  }, [location.state, navigate]);

  useEffect(() => {
    if (flights.length > 0) {
      setFilters((f) => ({ ...f, maxPrice: priceRange.max }));
    }
  }, [flights, inrToAed]);

  const filteredFlights = useMemo(() => {
    let list = flights.filter((f) => {
      const d = getDisplayData(f);
      const displayPrice = inrToAed ? d.price * inrToAed : d.price;
      if (displayPrice > filters.maxPrice) return false;
      if (filters.stops.length && !filters.stops.includes(d.stops > 1 ? 2 : d.stops)) return false;
      if (filters.depSlots.length && !filters.depSlots.includes(timeSlot(d.dep))) return false;
      if (filters.airlines.length && !filters.airlines.includes(d.airlineCode)) return false;
      if (filters.refundable.length && !filters.refundable.includes(d.refundable)) return false;
      return true;
    });
    if (sortTab === "Cheapest") {
      list = [...list].sort((a, b) => getDisplayData(a).price - getDisplayData(b).price);
    } else if (sortTab === "Fastest") {
      list = [...list].sort((a, b) => String(getDisplayData(a).durMin).localeCompare(String(getDisplayData(b).durMin)));
    } else {
      const maxP = Math.max(...list.map((f) => getDisplayData(f).price), 1);
      list = [...list].sort((a, b) => {
        const da = getDisplayData(a), db = getDisplayData(b);
        return (1 - db.price / maxP) - (1 - da.price / maxP);
      });
    }
    return list;
  }, [flights, filters, sortTab, inrToAed]);

  useEffect(() => { setVisibleCount(ITEMS_PER_PAGE); }, [filters, sortTab]);

  useEffect(() => {
    const handleScroll = () => {
      const scrolledToBottom =
        window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 300;
      if (scrolledToBottom) {
        setVisibleCount((prev) => {
          if (prev >= filteredFlights.length) return prev;
          return prev + ITEMS_PER_PAGE;
        });
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [filteredFlights.length]);

  const paginatedFlights = useMemo(() => {
    return filteredFlights.slice(0, visibleCount);
  }, [filteredFlights, visibleCount]);

  const totalPages = Math.ceil(filteredFlights.length / ITEMS_PER_PAGE) || 1;
  const currentPageDisplay = Math.min(Math.ceil(visibleCount / ITEMS_PER_PAGE), totalPages);
  const hasMore = visibleCount < filteredFlights.length;

  const tabMeta = useMemo(() => {
    const byPrice = [...filteredFlights].sort((a, b) => getDisplayData(a).price - getDisplayData(b).price);
    const cheapest = byPrice[0];
    const best = filteredFlights[0];
    return {
      Best:     { price: best     ? getDisplayData(best).price     : "-", dur: best     ? formatDur(getDisplayData(best).durMin)     : "-" },
      Cheapest: { price: cheapest ? getDisplayData(cheapest).price : "-", dur: cheapest ? formatDur(getDisplayData(cheapest).durMin) : "-" },
      Fastest:  { price: cheapest ? getDisplayData(cheapest).price : "-", dur: cheapest ? formatDur(getDisplayData(cheapest).durMin) : "-" },
    };
  }, [filteredFlights]);
  const searchData = location.state?.searchData;

  return (
    <div style={S.page}>
       {loading && (
  <AirplaneLoader 
    message={`Loading    flights from ${searchData?.Routs?.[0]?.Source || "DEL"} to ${searchData?.Routs?.[0]?.Destination || "BOM"}...`} 
  />
)}
      <div style={S.topBar}>
        <div style={S.metaRow}>
          {[
            [isRoundTripSearch ? "Round Trip" : "One Way", `${searchData?.Routs?.[0]?.Source || "DEL"} → ${searchData?.Routs?.[0]?.Destination || "BOM"}`],
            ["📅 Departure", searchData?.Routs?.[0]?.TravelDate || ""],
            isRoundTripSearch ? ["📅 Return", searchData?.Routs?.[1]?.TravelDate || ""] : null,
            ["Traveller", `Adult: ${searchData?.AdultCount || 1}, Child: ${searchData?.ChildCount || 0}, Infant: ${searchData?.InfantCount || 0}`],
         ["Class", CLASS_NAMES[searchData?.TypeOfClass] ?? "Economy"],
          ].filter(Boolean).map(([lbl, val]) => (
            <div key={lbl} style={S.metaItem}>
              <span style={S.metaLabel}>{lbl}</span>
              <span style={S.metaVal}>{val}</span>
            </div>
          ))}
        </div>
        <button style={S.modifyBtn} onClick={() => setShowModify((v) => !v)}>
          Modify {showModify ? "▲" : "▼"}
        </button>
      </div>

      {showModify && (
        <div style={{ maxHeight: 500 }}>
          <ModifyPanel tripType={tripType} setTripType={setTripType} navigate={navigate} searchData={searchData} />
        </div>
      )}

      <div style={S.mainArea}>
<FilterPanel
  filters={filters}
  setFilters={setFilters}
  availableAirlines={availableAirlines}
  priceRange={priceRange}
  aedRate={inrToAed}
/>
        <div style={S.resultsArea}>
          <div style={S.sortTabs}>
            {["Best", "Cheapest", "Fastest"].map((tab, i) => (
              <div key={tab} onClick={() => setSortTab(tab)} style={{ ...S.sortTab, background: sortTab === tab ? "#F0F4FF" : "#fff", borderRight: i < 2 ? "1px solid #E8EAF0" : "none" }}>
                <div style={{ fontWeight: 600, fontSize: 12, color: sortTab === tab ? "#1a73e8" : "#1a1a2e" }}>{tab}</div>
                <div style={{ fontSize: 11, color: "#9295A4" }}>
                  {typeof tabMeta[tab].price === "number" ? `₹${tabMeta[tab].price.toLocaleString("en-IN")}` : tabMeta[tab].price}
                  {" · "}{tabMeta[tab].dur}
                </div>
              </div>
            ))}
          </div>  

<div style={S.navBtns}>
  <button
    style={{ ...S.navBtn, opacity: visibleCount <= ITEMS_PER_PAGE ? 0.5 : 1 }}
    disabled={visibleCount <= ITEMS_PER_PAGE}
    onClick={() => setVisibleCount((v) => Math.max(ITEMS_PER_PAGE, v - ITEMS_PER_PAGE))}
  >
    ◀ Prev 10
  </button>

  <span style={{ padding: "6px 14px", fontSize: 12, color: "#6B6F80" }}>
    {filteredFlights.length} flights · Showing {Math.min(visibleCount, filteredFlights.length)} · Page {currentPageDisplay} / {totalPages}
  </span>

  <button
    style={{ ...S.navBtn, opacity: !hasMore ? 0.5 : 1 }}
    disabled={!hasMore}
    onClick={() => setVisibleCount((v) => v + ITEMS_PER_PAGE)}
  >
    Next 10 ▶
  </button>
</div>

          <div style={S.colHead}>
            <span>Airline</span>
            <span style={{ textAlign: "center" }}>Departure</span>
            <span style={{ textAlign: "center" }}>Duration</span>
            <span style={{ textAlign: "center" }}>Arrival</span>
            <span style={{ textAlign: "right" }}>Fare</span>
          </div>

          {paginatedFlights.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px 0", color: "#9295A4", fontSize: 14 }}>
              No flights match your filters.
            </div>
          ) : (
            <>
              {paginatedFlights.map((f, i) => (
                <FlightCard
                  key={i}
                  flight={f}
                  index={i}
                  sessionData={sessionData}
                  isDomestic={isDomestic}
                  searchData={searchData}
                  aedRate = {inrToAed}
                />
              ))}
              {hasMore && (
                <div style={S.loadingMore}>Scroll down to result more .....</div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );  
}